import { useState } from "react"
import { NotebookPen } from "lucide-react"
import { InterneAufgabeModal } from "@/components/portal/InterneAufgabeModal"

/**
 * Schnellzugriff „interne Aufgabe" — global, links neben der Suchlupe (#33).
 *
 * Gewünscht am 25.08.2026: „Können wir außerdem auf jeder seite neben der
 * suchlupe ein symbol für interne aufgabe erstellen hinzufügen?"
 *
 * 🔑 Bewusst dieselbe Größe und Optik wie der Lupen-Knopf, damit die beiden
 * als Paar gelesen werden und nicht wie ein verirrter Knopf aussehen. Die
 * Lupe sitzt fix auf `right: 24` — dieser hier davor, also weiter rechts
 * beginnend nach links: `right: 68` (36 px Knopf + 8 px Abstand).
 */
export function InterneAufgabeKnopf() {
  const [offen, setOffen] = useState(false)
  return (
    <>
      <div style={{ position: "fixed", top: "calc(12px + var(--stoerung-h, 0px))", right: 68, zIndex: 100 }}>
        <button
          type="button"
          onClick={() => setOffen(true)}
          title="Interne Aufgabe anlegen — bleibt im Portal"
          aria-label="Interne Aufgabe anlegen"
          style={{
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            width: 36, height: 36, borderRadius: 8,
            background: "#fff", border: "1px solid #e5e7eb",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)", cursor: "pointer", color: "#64748b",
          }}
        >
          <NotebookPen className="w-4 h-4" />
        </button>
      </div>
      <InterneAufgabeModal open={offen} onClose={() => setOffen(false)} />
    </>
  )
}
